import React from 'react'
import Header from 'components/app/Header'
import PageBody from 'components/app/PageBody'
import Breadcrumb from 'components/app/Breadcrumb'
import SettingsHeader from 'components/organization/SettingsHeader'
import SettingsContainer from 'components/organization/SettingsContainer'

export default function SettingsPage() {
  return (
    <PageBody
      renderHeader={() => (
        <>
          <Header>
            <Breadcrumb crumbs={[{ label: 'Settings', value: 'settings' }]} />
          </Header>
          <SettingsHeader />
        </>
      )}
      renderContent={() => <SettingsContainer />}
    />
  )
}
